import { getStorageValue, setStorageValue } from '@lingoda/utils';

const DISMISSED_TIMEZONE_KEY = 'differenceBarDismissedTimezone';

// we save user's local timezone in local storage to not show the bar again until local timezone is changed, e.g. user travels to another country
export const setDismissForTimezone = (timezone: string) =>
    setStorageValue(DISMISSED_TIMEZONE_KEY, timezone);

export const getDismissForTimezone = () => getStorageValue(DISMISSED_TIMEZONE_KEY);
